import * as types from './types';

const setItem = (item) => ({
  type: types.SET_ITEM,
  data: item,
});

const setItems = (items) => ({
  type: types.SET_ITEMS,
  data: items,
});

const setItemPackage = (itemPackage) => ({
  type: types.SET_ITEM_PACKAGE,
  data: itemPackage,
});

const setSearchSummary = (searchSummary) => ({
  type: types.SET_SEARCH_SUMMARY,
  data: searchSummary,
});

export { setItem, setItems, setItemPackage, setSearchSummary };
